var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.navMobileSection === 'true')?_c('md-list',{staticClass:"nav-mobile-menu nav-mobile-section"},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }